import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=e8fdc8f6&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"
import style0 from "./Language.vue?vue&type=style&index=0&id=e8fdc8f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fdc8f6",
  null
  
)

export default component.exports